<script setup>
import {onBeforeMount, ref, reactive} from "vue";
import YTCard from "@/components/YTCard/YTCard.vue";
import {getRoute} from "@/hooks/getRoute.js";
import router from "@/router/index.js";
import {detailInvoice, invoiceRed} from "@/api/invoice/invoice.js";
import YTInvoiceState from "@/components/YTInvoiceState/index.vue";
import QRCode from 'qrcode';

// 路由信息
const {route} = getRoute();
// 是否有发票id
const hasInvoice = ref(false)
// 加载状态
const loading = ref(false)
onBeforeMount(async () => {
  hasInvoice.value = Boolean(route.query.invoiceId)
  // 检测是否携带发票id
  if (!hasInvoice.value) {
    loading.value = true
    ElMessage.error("暂无发票信息")
    return
  }
  await handleSearch()
})

// 获取发票信息
const handleSearch = async () => {
  try {
    loading.value = true
    const res = await detailInvoice(route.query.invoiceId)
    formData.invoiceId = res.invoiceId
    formData.invoiceCode = res.invoiceCode
    formData.invoiceNo = res.invoiceNo
    formData.orderNo = res.orderNo
    formData.state = res.state
    formData.invoiceType = res.invoiceType
    formData.amountWithTax = res.amountWithTax
    formData.noTaxAmount = res.noTaxAmount
    formData.taxAmount = res.taxAmount
    formData.invoiceDate = res.invoiceDate
    formData.taxpayerNum = res.taxpayerNum
    formData.buyerTaxpayerNum = res.buyerTaxpayerNum
    formData.buyerName = res.buyerName
    formData.drawerName = res.drawerName
    formData.casherName = res.casherName
    formData.reviewerName = res.reviewerName
    formData.invoiceUrl = res.invoiceUrl
    formData.invoiceItems = res.invoiceItems
    // 发票处理成二维码显示
    QRCode.toString(formData.invoiceUrl, {type: 'svg', width: 250}, (err, svg) => {
      if (err) {
        console.error('二维码生成失败', err)
      } else {
        formData.QRUrl = svg
      }
    })
    loading.value = false
  } catch (e) {
    console.log(e)
  }
}

/*发票相关*/
// 发票详情信息
const formData = reactive({
  invoiceId: null,
  invoiceCode: null,
  invoiceNo: null,
  orderNo: null,
  state: null,
  invoiceType: null,
  amountWithTax: 0.00,
  noTaxAmount: 0.00,
  taxAmount: 0.00,
  invoiceDate: null,
  taxpayerNum: null,
  buyerTaxpayerNum: null,
  buyerName: null,
  drawerName: null,
  casherName: null,
  reviewerName: null,
  invoiceUrl: null,
  QRUrl: null,
  invoiceItems: []
})
// 开票项目
const headers = ref([
  { title: '商品名称', key: 'goodsName', nowrap: true },
  { title: '数量', key: 'quantity', nowrap: true },
  { title: '单价', key: 'unitPrice', nowrap: true },
  { title: '总额', key: 'invoiceAmount', nowrap: true },
  { title: '税率', key: 'taxRateValue', nowrap: true },
  { title: '税额', key: 'taxRateAmount', nowrap: true },
])
// 处理发票冲红
const handleInvoiceRed = async () => {
  await invoiceRed(formData.invoiceId)
  router.push({ path: '/listInvoice' })
}
</script>

<template>
  <el-form
      :model="formData"
      label-position="right"
      label-width="100px"
  >
    <div class="container_box mg_b_2" style="padding-bottom: 0;">
      <YTCard ref="baseRef" :title="'基本信息'" :is-show-divider="false" :is-show-title-line="true" :is-retract="false" :isCollapsed="true">
        <template #container>
          <v-skeleton-loader
              :loading="loading"
              type="list-item-three-line"
          >
            <div class="flex_bt flex_align_t w-100">
              <div style="max-width: 600px">
                <el-form-item label="发票代码：" prop="invoiceCode">
                  <el-text class="mx-1" v-text="formData.invoiceCode"></el-text>
                </el-form-item>
                <el-form-item label="发票号码：" prop="invoiceNo">
                  <el-text class="mx-1" v-text="formData.invoiceNo"></el-text>
                </el-form-item>
                <el-form-item label="订单编号：" prop="orderNo">
                  <el-text class="mx-1" v-text="formData.orderNo"></el-text>
                </el-form-item>
                <el-form-item label="状态：" prop="state">
                  <YTInvoiceState class="mx-1" :state="formData.state"></YTInvoiceState>
                </el-form-item>
                <el-form-item label="发票类型：" prop="invoiceType">
                  <el-text class="mx-1" type="info" v-text="'未知类型'" v-if="formData.invoiceType !== 1 && formData.invoiceType !== 2"></el-text>
                  <el-text class="mx-1" :type="formData.invoiceType === 1 ? 'primary' : 'danger'" v-text="formData.invoiceType === 1 ? '蓝票' : '红票'" v-else></el-text>
                </el-form-item>
                <el-form-item label="含税金额：" prop="amountWithTax">
                  <el-text class="mx-1" v-text="formData.amountWithTax"></el-text>
                </el-form-item>
                <el-form-item label="不含税金额：" prop="noTaxAmount">
                  <el-text class="mx-1" v-text="formData.noTaxAmount"></el-text>
                </el-form-item>
                <el-form-item label="税额：" prop="taxAmount">
                  <el-text class="mx-1" v-text="formData.taxAmount"></el-text>
                </el-form-item>
                <el-form-item label="发票日期：" prop="invoiceDate">
                  <el-text class="mx-1" v-text="formData.invoiceDate"></el-text>
                </el-form-item>
                <el-form-item label="销方税号：" prop="taxpayerNum">
                  <el-text class="mx-1" v-text="formData.taxpayerNum"></el-text>
                </el-form-item>
                <el-form-item label="购买方税号：" prop="buyerTaxpayerNum">
                  <el-text class="mx-1" v-text="formData.buyerTaxpayerNum"></el-text>
                </el-form-item>
                <el-form-item label="购买方名称：" prop="buyerName">
                  <el-text class="mx-1" v-text="formData.buyerName"></el-text>
                </el-form-item>
                <el-form-item label="开票人：" prop="drawerName">
                  <el-text class="mx-1" v-text="formData.drawerName"></el-text>
                </el-form-item>
                <el-form-item label="收款人：" prop="casherName">
                  <el-text class="mx-1" v-text="formData.casherName"></el-text>
                </el-form-item>
                <el-form-item label="复核人：" prop="reviewerName">
                  <el-text class="mx-1" v-text="formData.reviewerName"></el-text>
                </el-form-item>
              </div>
              <div>
                <el-form-item label="发票预览：" prop="invoiceUrl">
                  <div>
                    <div v-html="formData.QRUrl"></div>
                    <div class="tips_default txt_center">
                      <text>请扫描二维码或</text>
                      <el-link type="primary" target="_blank" :href="formData.invoiceUrl" :underline="false">点击查看</el-link>
                    </div>
                  </div>
                </el-form-item>
              </div>
            </div>
          </v-skeleton-loader>
        </template>
      </YTCard>
    </div>
    <div class="container_box mg_b_2" style="padding-bottom: 0">
      <YTCard :title="'开票项目'" :is-show-divider="false" :is-show-title-line="true" :is-retract="false" :isCollapsed="true">
        <template #container>
          <v-skeleton-loader
              :loading="loading"
              type="list-item-three-line"
          >
            <div class="flex_bt flex_align_t w-100">
              <v-data-table
                  :headers="headers"
                  :items="formData.invoiceItems"
                  :loading="loading"
                  :no-data-text="'没有更多数据了~'"
                  no-filter
                  hover
              >
                <template v-slot:bottom>

                </template>
              </v-data-table>
            </div>
          </v-skeleton-loader>
        </template>
      </YTCard>
    </div>
    <div class="container_box mg_b_2" style="padding-bottom: 0">
      <YTCard :title="'发票状态'" :is-show-divider="false" :is-show-title-line="true" :is-retract="false" :isCollapsed="true">
        <template #container>
          <v-skeleton-loader
              :loading="loading"
              type="list-item"
          >
            <el-form-item label="发票状态：" prop="orderState">
              <YTInvoiceState class="mg_r_2" :state="formData.state"></YTInvoiceState>
              <el-popconfirm @confirm="handleInvoiceRed()" :title="`确定此发票冲红吗？`">
                <template #reference>
                  <div>
                    <v-btn color="success" v-if="formData.invoiceType === 1" :disabled="!$handleHasBtnPermission('all', 'adminInvoice:view:edit')">发票冲红</v-btn>
                  </div>
                </template>
                <template #actions="{ confirm, cancel }">
                  <div class="flex_bt">
                    <v-btn size="small" @click="cancel">取消</v-btn>
                    <v-btn size="small" color="primary" @click="confirm">确定</v-btn>
                  </div>
                </template>
              </el-popconfirm>
            </el-form-item>
          </v-skeleton-loader>
        </template>
      </YTCard>
    </div>
    <div>
      <v-row>
        <v-col>
          <v-btn @click="router.back()">返回</v-btn>
        </v-col>
      </v-row>
    </div>
  </el-form>
</template>

<style scoped>

</style>